export default __webpack_public_path__ + "static/media/teamwork.a42f0336.svg";